import type { MessageDescriptor } from 'react-intl';
import { MeiliIndex } from '../SearchField/types';
import { commandPaletteMessages as messages } from './commandPaletteMessages';

/** The heading of each result section in the palette. */
export const paletteSectionLabels: Record<MeiliIndex, MessageDescriptor> = {
  [MeiliIndex.artists]: messages.sectionArtists,
  [MeiliIndex.tracks]: messages.sectionTracks,
  [MeiliIndex.playlists]: messages.sectionPlaylists,
};
